import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Clients } from './pages/Clients';
import { Invoices } from './pages/Invoices';
import { Jobs } from './pages/Jobs';
import { Account } from './pages/Account';
import { Reporting } from './pages/Reporting';
import { Settings } from './pages/Settings';
import { Timesheets } from './pages/Timesheets';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rlyr0hc56qkk">
      <Routes data-id="element-1" data-mp="2rlf74v2xls3w">
        <Route path="/" element={<Navigate to="/jobs" replace data-id="element-3" data-mp="2mluawsf5bxuv" />} data-id="element-2" data-mp="2rit1j0zlpmob" />
        <Route path="/clients" element={<Clients data-id="element-5" data-mp="2mjpvbd7vxaer" />} data-id="element-4" data-mp="2mmvob3jmwwfr" />
        <Route path="/jobs" element={<Jobs data-id="element-7" data-mp="31ayqe1uk3nza" />} data-id="element-6" data-mp="31aqfgfhzusqq" />
        <Route path="/invoices" element={<Invoices data-id="element-9" data-mp="31ctbbg5tvg3d" />} data-id="element-8" data-mp="31bi9vmzuukff" />
        <Route path="/timesheets" element={<Timesheets data-id="element-11" data-mp="2wiyuqllirh8i" />} data-id="element-10" data-mp="2wka1mua9h53u" />
        <Route path="/reporting" element={<Reporting data-id="element-13" data-mp="28ufm24yk52fw" />} data-id="element-12" data-mp="2wip7h5ruzo6i" />
        <Route path="/settings" element={<Settings data-id="element-15" data-mp="28surifc8tji1" />} data-id="element-14" data-mp="28tmdqzjya4vn" />
        <Route path="/account" element={<Account data-id="element-17" data-mp="23vuq4hqc94x9" />} data-id="element-16" data-mp="28s2xh8yanttv" />
      </Routes>
    </BrowserRouter>;
}